import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ISideboard } from '@app/side-board/ISideboard';
import { TemplateService } from '@app/template/template.service';
import { OfflineService, PhdsoftCommonService } from '@phdsoft/common';
import { IWindow } from '@phdsoft/window';
import { CrudBasicDomains } from 'projects/phdsoft/common/src/lib/models/crud-basic-domains.model';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { CrudBasicDomainsService } from 'src/app/admin/services/crud-basic-domains.service';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import { CollectionInspectionTypeService } from 'src/app/collections/collection-inspection-type/collection-inspection-type.service';
import { InspectionPlanAssistantComponent, IPACData } from 'src/app/collections/inspection-plan-assistant/inspection-plan-assistant.component';
import { CollectionInspectionGauginsWizardService } from 'src/app/automatic-points/collection-inspection-gaugins-positioning-wizard/collection-inspection-gaugins-wizard.service';
import { v4 as uuidv4 } from 'uuid'
import { AutomaticPlanAreaWizardService } from '../automatic-plan-area-wizard/automatic-plan-area-wizard.service';

export type InspectionMethodNameType = 'Point' | 'Area' | 'Element'

export interface IAutomaticPlanTypeSelectorData {
  inspectionTypeId: string
  inspectionTypeName: string
  inspectionMethodId: string
  inspectionMethodName: InspectionMethodNameType
  checkLists: ICheckList[]
}

export interface ICheckList {
  Id: string;
  StatusId: string;
  InputTypeId: string;
  Label: string;
  Name: any;
  Value: string;
  Comments: string;
  Degree: number;
  Recommendations: string;
  Description: any;
  PhotoExplanation: any;
  Date: Date;
  Attachments: string[];
  Measurements: string[];
  AttributesList: string[];
  InspectionSubTypeId: string
}
@Component({
  selector: 'phdsoft-automatic-plan-type-selector',
  templateUrl: './automatic-plan-type-selector.component.html',
  styleUrls: ['./automatic-plan-type-selector.component.scss']
})
export class AutomaticPlanTypeSelectorComponent implements OnInit {
  @Output() planTypeSelected = new EventEmitter<IAutomaticPlanTypeSelectorData>();

  inspectionTypeId: string;
  regionIds: string[] = [];
  showPlanSelector = false;

  listInpectionType: CrudBasicDomains[] = [];

  listInpectionTypeTemp: CrudBasicDomains[] = [];

  listItens: CrudBasicDomains[] = [];

  form: FormGroup;

  private unsubscribe$ = new Subject<void>();

  sub: Subscription;

  subData: Subscription;

  loading = false;

  notFound = false;


  optionsWindow: ISideboard = {
    VisibleMini: true,
    VisibleClose: true,
    Header: {
      VisibleTitle: true,
      Title: 'Bot Insertion',
      Visible: true
    },
    Footer: {
      Visible: false
    }
  };

  constructor(
    private changeRef: ChangeDetectorRef,
    private serviceCrud: CrudBasicDomainsService,
    private serviceCommon: PhdsoftCommonService,
    private serviceType: CollectionInspectionTypeService,
    private readonly assetManager: AssetManager,
    private readonly offLineService: OfflineService,
    private dialog: MatDialog,
    private templateService: TemplateService,
    private collectionInspectionGauginsWizardService: CollectionInspectionGauginsWizardService,
    private automaticPlanAreaWizardService: AutomaticPlanAreaWizardService,
    private snackBar: MatSnackBar
  ) {

  }

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.loadInspectionType();
    this.changeRef.detectChanges();
  }

  initForm(): void {
    this.form = new FormGroup({
      Search: new FormControl(''),
    });

    this.sub = this.form.controls.Search
      .valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.listInpectionType = this.serviceCommon.filter(value, this.listInpectionTypeTemp);
      });

  }

  async loadInspectionType(): Promise<void> {
    this.loading = true;

    this.notFound = false;

    if (window.navigator.onLine){
      this.serviceCrud.getCrudBasicDomainsInspectionList(this.assetManager.GetAssetInspectionTypes())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async (types: CrudBasicDomains) => {
        this.populateVariables(types)
      },
        error => {
          this.loading = false;
          console.error('[CollectionInspectionTypeSlct] => loadInspectionType: ', error);
        }
      );
    }
    else{
      let types = await this.offLineService.getItem(`inspectionTypes_${this.assetManager.asset.assetInfo.id}`);
      this.populateVariables(types.json);
    }
  }

  populateVariables(types){
    if (types?.listRows?.length > 0) {
      this.assetManager.listInpectionType = types?.listRows;
      this.listInpectionType = types?.listRows;
      this.listInpectionTypeTemp = types?.listRows;

      let keys = ['id', 'name'];

      if (this.listInpectionType?.length > 0) {
        keys = Object.keys(this.listInpectionType[0]);
      }

      this.serviceCommon.createStringFilter(this.listInpectionTypeTemp, keys).then(list => {
        this.listInpectionTypeTemp = [...list];
        this.listInpectionType = this.listInpectionTypeTemp;
      });
    } else {
      this.notFound = true;
    }
    this.loading = false;
  }

  onSubmit(): void {

  }

  onPlanSelected(plan: any): void {
    if (plan) {
      // Update the reference date and proceed with the inspection
      this.assetManager.referenceDate = new Date(plan.plannedDate);
    }

    // Get the currently selected inspection type and method
    const selectedType = this.templateService.automaticPlanTypeSelectorData;
    if (selectedType) {
      const checkLists = this.createCheckListForAutomaticPlan(this.inspectionTypeId);
      selectedType.checkLists = checkLists;

      if (selectedType.inspectionMethodName === 'Point') {
        console.log('Executing point wizard', selectedType);
        console.log('Plan selected', plan);
        this.executePointWizard(
          selectedType.inspectionTypeId,
          selectedType.inspectionMethodId,
          selectedType.inspectionTypeName,
          selectedType.checkLists
        );
      } 
      else if (selectedType.inspectionMethodName === 'Area') {
        console.log('Executing area wizard', selectedType);
        console.log('Plan selected', plan);
        this.executeAreaWizard(
          selectedType.inspectionTypeId,
          selectedType.inspectionMethodId,
          selectedType.inspectionTypeName,
          selectedType.checkLists
        );
      }
      else {
        this.openAdvancedConfig(
          { id: selectedType.inspectionTypeId, name: selectedType.inspectionTypeName },
          { id: selectedType.inspectionMethodId, name: selectedType.inspectionMethodName }
        );
      }
      
      // Close the selector panel after executing
      this.close();
    }
    this.showPlanSelector = false;
  }

  private executeInspection(): void {
    // Get the currently selected inspection type and method
    const selectedType = this.templateService.automaticPlanTypeSelectorData;
    if (selectedType) {
      this.changeType(
        { id: selectedType.inspectionTypeId, name: selectedType.inspectionTypeName },
        { id: selectedType.inspectionMethodId, name: selectedType.inspectionMethodName }
      );
    }
  }

  changeType(item: any, itemChild: any): void {
    const checkLists = this.createCheckListForAutomaticPlan(item.id);
    const IPTSData: IAutomaticPlanTypeSelectorData = {
      inspectionTypeId: item.id,
      inspectionTypeName: item.name,
      inspectionMethodId: itemChild.id,
      inspectionMethodName: itemChild.name,
      checkLists: checkLists
    };

    this.templateService.automaticPlanTypeSelectorData = IPTSData;
    this.inspectionTypeId = item.id;
    this.regionIds = this.assetManager.asset.GetVisibleRegions().map(x => x.Guid);
    this.showPlanSelector = true;
  }

  /**
   * Opens the advanced configuration assistant
   */
  openAdvancedConfig(item: any, itemChild: any): void {
    const checkLists = this.createCheckListForAutomaticPlan(item.id);
    const IPTSData: IAutomaticPlanTypeSelectorData = {
      inspectionTypeId: item.id,
      inspectionTypeName: item.name,
      inspectionMethodId: itemChild.id,
      inspectionMethodName: itemChild.name,
      checkLists: checkLists
    };

    this.templateService.automaticPlanTypeSelectorData = IPTSData;

    this.templateService.toggleInspectionPlanAssistant(true, {
      type: 'Automatic',
      inspectionTypeId: item.id
    } as IPACData);

    // Close the selector panel
    this.close();
  }

  /**
   * Executes the point wizard with default configuration
   */
  async executePointWizard(inspectionTypeId: string, inspectionMethodId: string, inspectionTypeName: string, checkLists: ICheckList[]): Promise<void> {
    try {
      this.loading = true;
      
      // Show processing message
      this.snackBar.open('Generating automatic points...', 'Processing', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
      
      // Execute the wizard with default configuration
      const response = await this.collectionInspectionGauginsWizardService.executeWithDefaultConfig(
        inspectionTypeId,
        inspectionMethodId,
        inspectionTypeName,
        checkLists
      );
      
      console.log('Successfully requested automatic points', response);
      
    } catch (error) {
      console.error('Error generating automatic points', error);
      
      // Show error message
      this.snackBar.open('Error generating automatic points. Please try again.', 'Error', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['error-snackbar']
      });
    } finally {
      this.loading = false;
    }
  }
  
  async executeAreaWizard(inspectionTypeId: string, inspectionMethodId: string, inspectionTypeName: string, checkLists: ICheckList[]): Promise<void> {
    try {
      this.loading = true;
      
      // Show processing message
      this.snackBar.open('Generating automatic areas...', 'Processing', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
      
      // Execute the wizard with default configuration
      const response = await this.automaticPlanAreaWizardService.executeWithDefaultConfig(
        inspectionTypeId,
        inspectionMethodId,
        inspectionTypeName,
        checkLists
      );
      
      console.log('Successfully requested automatic areas', response);
      
    } catch (error) {
      console.error('Error generating automatic areas', error);
      
      // Show error message
      this.snackBar.open('Error generating automatic areas. Please try again.', 'Error', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['error-snackbar']
      });
    } finally {
      this.loading = false;
    }
  }

  createCheckListForAutomaticPlan(inspectionTypeId: string): ICheckList[] {
    const inspectionType = this.assetManager.listInpectionType.find(x => x.id == inspectionTypeId)
    return inspectionType.listRows.map(x => {
      return {
        Id: uuidv4() as string,
        StatusId: '',
        InputTypeId: x.inputTypeId,
        Label: x.name,
        Name: null,
        Value: '',
        Comments: x.Comments,
        Degree: 0,
        Recommendations: '',
        Description: null,
        PhotoExplanation: null,
        Date: this.assetManager.referenceDate,
        Attachments: [] as string[],
        Measurements: [] as string[],
        AttributesList: x.attributesList as string[] ?? [] as string[],
        InspectionSubTypeId: x.id
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  close(): void {
    this.templateService.toggleAutomaticPlanTypeSelector(false);
  }

}
